import { Component, OnInit, Input } from '@angular/core';
import { take, catchError } from 'rxjs/operators';
import { WarehouseLocation } from '../../models/warehouse-location.model';
import { Warehouse } from '../../models/warehouse.model';
import { WarehouseService } from '../../services/warehouse.service';

@Component({
    selector: 'app-warehouse-location-form',
    templateUrl: './warehouse-location-form.component.html',
    styleUrls: ['./warehouse-location-form.component.scss'],
    standalone: false
})
export class WarehouseLocationFormComponent implements OnInit {

  @Input()
  warehouseLocation: WarehouseLocation;

  warehouses: Warehouse[] = [];

  constructor(private warehouseService: WarehouseService) { }

  ngOnInit(): void {
    this.loadWarehouses();
  }

  loadWarehouses() {
    this.warehouseService.getAllWarehouses()
    .pipe(take(1))
    .pipe(catchError((e) => {
      if (e.status === 403 || e.status === 401) {
        return e;
      }
      alert("Cannot load warehouses");
      return e;
    }))
    .subscribe((data: Warehouse[]) => {
      this.warehouses = data;
    })
  }
}
